<template>
  <v-row no-gutters class="white" style="overflow: hidden">
    <v-col class="col-12">
      <v-alert
        class="my-0 pt-8 px-8 text-center"
        border="top"
        colored-border
        :type="notifier.type || type"
        tile
        elevation="0"
      >
        <!-- <span>{{ message }}</span> -->
        <p  class="pl-1" v-html="message || notifier.message" />
      </v-alert>
    </v-col>
    <v-col class="col-12">
      <div align="center" justify="center" class="pt-2 mb-5">
        <v-btn
          color="leading"
          width="150"
          dark
          class
          @click.native="$emit('close')"
        >
          Volver
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: () => '',
    },
    type: {
      type: String,
      default: () => 'info',
    },
  },
  computed: {
    notifier() {
      return this.$store.state.process.notifier;
    },
  },
};
</script>
<style scoped>
/* p{
  line-height: 3rem;
} */
>>> .v-alert__icon.v-icon {
  font-size: 25px !important;
  margin: 0;
}
</style>
